import apiConfig from "../../config/apiConfig";

export const WORKFLOW_PORT = 8000;
export const WORKFLOW_BASE_URL = `http://localhost:${WORKFLOW_PORT}/api`;

// Re-export DMS helpers from the central apiConfig for backward compatibility
export const getDmsUploadUrl = apiConfig.DMS_BASE_URL;
export const DMS_UPLOAD_URL = apiConfig.getDmsUploadUrl();
